import React from 'react';
import { MotionImage, MotionCard, MotionLink } from '../ui/MotionPrimitives';
import TwitterIcon from '@mui/icons-material/Twitter';
import InstagramIcon from '@mui/icons-material/Instagram';
import FacebookIcon from '@mui/icons-material/Facebook';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import MusicNoteIcon from '@mui/icons-material/MusicNote';

const Footer: React.FC = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="w-full bg-black text-white">
      {/* Top section */}
      <div className="mx-auto max-w-6xl px-6 py-10 md:px-10 md:py-12">
        <div className="grid gap-10 md:grid-cols-4 md:gap-12">
          {/* Brand + tagline */}
          <div>
            <div className="flex items-center gap-3">
              <MotionImage
                src="/logo/Hogar Dorado House Logo 1.svg"
                alt="Hogar Dorado House logo"
                className="h-16 w-auto md:h-20"
              />
            </div>

            <p className="mt-4 max-w-xs text-sm text-white/60">
              Strategic Real Estate. Global Impact.
            </p>

            <div className="mt-4 flex items-center gap-3 text-white/60">
              <a
                href="https://x.com/HogarDoradoHse"
                target="_blank"
                rel="noopener noreferrer"
                className="flex h-8 w-8 items-center justify-center rounded-full bg-white/5 text-white/70 transition hover:bg-white/10 hover:text-white"
              >
                <TwitterIcon fontSize="small" />
              </a>
              <a
                href="https://www.instagram.com/hogardoradohouse/"
                target="_blank"
                rel="noopener noreferrer"
                className="flex h-8 w-8 items-center justify-center rounded-full bg-white/5 text-white/70 transition hover:bg-white/10 hover:text-white"
              >
                <InstagramIcon fontSize="small" />
              </a>
              <a
                href="https://www.facebook.com/hogardoradohouse"
                target="_blank"
                rel="noopener noreferrer"
                className="flex h-8 w-8 items-center justify-center rounded-full bg-white/5 text-white/70 transition hover:bg-white/10 hover:text-white"
              >
                <FacebookIcon fontSize="small" />
              </a>
              <a
                href="https://www.linkedin.com/company/hogar-dorado-house/"
                target="_blank"
                rel="noopener noreferrer"
                className="flex h-8 w-8 items-center justify-center rounded-full bg-white/5 text-white/70 transition hover:bg-white/10 hover:text-white"
                aria-label="LinkedIn"
              >
                <LinkedInIcon fontSize="small" />
              </a>
              <a
                href="https://www.tiktok.com/@hogardoradohouse"
                target="_blank"
                rel="noopener noreferrer"
                className="flex h-8 w-8 items-center justify-center rounded-full bg-white/5 text-white/70 transition hover:bg-white/10 hover:text-white"
                aria-label="TikTok"
              >
                <MusicNoteIcon fontSize="small" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <MotionCard>
            <h4 className="text-sm font-semibold text-white">
              Quick Links
            </h4>

            <div className="mt-2 h-px w-10 bg-white/20" />
            <ul className="mt-3 space-y-1.5 text-sm text-white/65">
              <li>
                <MotionLink to="/" className="hover:text-white">
                  Home
                </MotionLink>
              </li>
              <li>
                <MotionLink to="/about" className="hover:text-white">
                  Our Expertise
                </MotionLink>
              </li>
              <li>
                <MotionLink to="/services" className="hover:text-white">
                  Full Services
                </MotionLink>
              </li>
              <li>
                <MotionLink to="/contact" className="hover:text-white">
                  Contact Us
                </MotionLink>
              </li>
            </ul>
          </MotionCard>

          {/* Global Markets */}
          <MotionCard>
            <h4 className="text-sm font-semibold text-white">
              Global Markets
            </h4>

            <div className="mt-2 h-px w-10 bg-white/20" />
            <ul className="mt-3 space-y-1.5 text-sm text-white/65">
              <li>UAE Investment (Dubai)</li>
              <li>USA Investment (Metropolitan)</li>
              <li>Development &amp; Construction</li>
              <li>Hospitality Sector</li>
            </ul>
          </MotionCard>

          {/* Legal */}
          <MotionCard>
            <h4 className="text-sm font-semibold text-white">
              Legal
            </h4>

            <div className="mt-2 h-px w-10 bg-white/20" />
            <ul className="mt-3 space-y-1.5 text-sm text-white/65">
              <li>Privacy Policy</li>
              <li>Terms of Service</li>
            </ul>
          </MotionCard>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-white/10">
        <div className="mx-auto flex max-w-6xl flex-col items-center justify-between gap-2 px-6 py-4 text-xs text-white/40 md:flex-row md:px-10">
          <span>&copy; {year} Hogar Dorado House. All rights reserved.</span>
          <span>
            Designed by{' '}
            <a
              href="https://www.spemedia.co.zw/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-white/60 underline-offset-2 hover:text-white hover:underline"
            >
              Spemedia
            </a>
          </span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;